// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#xmlfields_fieldtypeId {
  margin-left: 0px !important;
}

.fieldset-form {
  margin-top: 20px;
}

.mat-mdc-raised-button > .mat-icon {
  width: 36px;
  height: 36px;
  padding: 5px;
}

@media (max-width: 576px) {
  .container input.form-control {
    margin-bottom: 5px;
  }
  .mat-mdc-dialog-actions .mat-mdc-button-base + .mat-mdc-button-base {
    margin-left: 0 !important;
  }
  .margencorector {
    margin-top: 10px;
  }
  .ajustemovil {
    padding-left: 0;
    padding-right: 0;
  }
}
.custom-check-card {
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.2s ease;
}

.custom-check-card .form-check-input {
  margin-top: 0;
  cursor: pointer;
}

.custom-check-card .form-check-label {
  cursor: pointer;
  word-break: break-word;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
